module.exports = __webpack_public_path__ + "static/media/graphql-documentation.1a1e5498.png";